"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../Input"));
var _hooks = require("../../hooks");
var _excluded = ["className", "onChange", "externalValue"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// TODO: this is desktop only component
var InputFilter = function InputFilter(_ref, ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    externalValue = _ref.externalValue,
    inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(externalValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  (0, _react.useEffect)(function () {
    setValue(externalValue);
  }, [externalValue]);
  var debouncedValue = (0, _hooks.useDebounce)(value, 900);
  (0, _hooks.useDidUpdate)(function () {
    return onChange(debouncedValue);
  }, [debouncedValue]);
  return /*#__PURE__*/_react["default"].createElement(StyledInputFilter, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledInput, (0, _extends2["default"])({}, inputProps, {
    ref: ref,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  })));
};
var StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "InputFilter__StyledInput",
  componentId: "sc-yehnzd-0"
})(["width:100%;height:32px;background:transparent;"]);
var StyledInputFilter = _styledComponents["default"].div.withConfig({
  displayName: "InputFilter__StyledInputFilter",
  componentId: "sc-yehnzd-1"
})(["position:relative;"]);
InputFilter.propTypes = _objectSpread(_objectSpread({}, _Input["default"].propTypes), {}, {
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired
});
InputFilter.defaultProps = {
  className: '',
  defaultValue: ''
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(InputFilter);